
import { useState,useEffect } from "react";


import input_check from "../input_check.png";
import input_error from "../input_error.png";


function InputPhone(props)
{
    const numbs = [
  { "country": "Afghanistan", "iso2": "AF", "dial_code": "+93" },
  { "country": "Albania", "iso2": "AL", "dial_code": "+355" },
  { "country": "Algeria", "iso2": "DZ", "dial_code": "+213" },
  { "country": "American Samoa", "iso2": "AS", "dial_code": "+1-684" },
  { "country": "Andorra", "iso2": "AD", "dial_code": "+376" },
  { "country": "Angola", "iso2": "AO", "dial_code": "+244" },
  { "country": "Anguilla", "iso2": "AI", "dial_code": "+1-264" },
  { "country": "Antarctica", "iso2": "AQ", "dial_code": "+672" },
  { "country": "Antigua and Barbuda", "iso2": "AG", "dial_code": "+1-268" },
  { "country": "Argentina", "iso2": "AR", "dial_code": "+54" },
  { "country": "Armenia", "iso2": "AM", "dial_code": "+374" },
  { "country": "Aruba", "iso2": "AW", "dial_code": "+297" },
  { "country": "Australia", "iso2": "AU", "dial_code": "+61" },
  { "country": "Austria", "iso2": "AT", "dial_code": "+43" },
  { "country": "Azerbaijan", "iso2": "AZ", "dial_code": "+994" },
  { "country": "Bahamas", "iso2": "BS", "dial_code": "+1-242" },
  { "country": "Bahrain", "iso2": "BH", "dial_code": "+973" },
  { "country": "Bangladesh", "iso2": "BD", "dial_code": "+880" },
  { "country": "Barbados", "iso2": "BB", "dial_code": "+1-246" },
  { "country": "Belarus", "iso2": "BY", "dial_code": "+375" },
  { "country": "Belgium", "iso2": "BE", "dial_code": "+32" },
  { "country": "Belize", "iso2": "BZ", "dial_code": "+501" },
  { "country": "Benin", "iso2": "BJ", "dial_code": "+229" },
  { "country": "Bermuda", "iso2": "BM", "dial_code": "+1-441" },
  { "country": "Bhutan", "iso2": "BT", "dial_code": "+975" },
  { "country": "Bolivia", "iso2": "BO", "dial_code": "+591" },
  { "country": "Bosnia and Herzegovina", "iso2": "BA", "dial_code": "+387" },
  { "country": "Botswana", "iso2": "BW", "dial_code": "+267" },
  { "country": "Brazil", "iso2": "BR", "dial_code": "+55" },
  { "country": "British Indian Ocean Territory", "iso2": "IO", "dial_code": "+246" },
  { "country": "Brunei", "iso2": "BN", "dial_code": "+673" },
  { "country": "Bulgaria", "iso2": "BG", "dial_code": "+359" },
  { "country": "Burkina Faso", "iso2": "BF", "dial_code": "+226" },
  { "country": "Burundi", "iso2": "BI", "dial_code": "+257" },
  { "country": "Cambodia", "iso2": "KH", "dial_code": "+855" },
  { "country": "Cameroon", "iso2": "CM", "dial_code": "+237" },
  { "country": "Canada", "iso2": "CA", "dial_code": "+1" },
  { "country": "Cape Verde", "iso2": "CV", "dial_code": "+238" },
  { "country": "Cayman Islands", "iso2": "KY", "dial_code": "+1-345" },
  { "country": "Central African Republic", "iso2": "CF", "dial_code": "+236" },
  { "country": "Chad", "iso2": "TD", "dial_code": "+235" },
  { "country": "Chile", "iso2": "CL", "dial_code": "+56" },
  { "country": "China", "iso2": "CN", "dial_code": "+86" },
  { "country": "Colombia", "iso2": "CO", "dial_code": "+57" },
  { "country": "Comoros", "iso2": "KM", "dial_code": "+269" },
  { "country": "Congo", "iso2": "CG", "dial_code": "+242" },
  { "country": "Costa Rica", "iso2": "CR", "dial_code": "+506" },
  { "country": "Croatia", "iso2": "HR", "dial_code": "+385" },
  { "country": "Cuba", "iso2": "CU", "dial_code": "+53" },
  { "country": "Cyprus", "iso2": "CY", "dial_code": "+357" },
  { "country": "Czech Republic", "iso2": "CZ", "dial_code": "+420" },
  { "country": "Denmark", "iso2": "DK", "dial_code": "+45" },
  { "country": "Djibouti", "iso2": "DJ", "dial_code": "+253" },
  { "country": "Dominica", "iso2": "DM", "dial_code": "+1-767" },
  { "country": "Dominican Republic", "iso2": "DO", "dial_code": "+1-809" },
  { "country": "Ecuador", "iso2": "EC", "dial_code": "+593" },
  { "country": "Egypt", "iso2": "EG", "dial_code": "+20" },
  { "country": "El Salvador", "iso2": "SV", "dial_code": "+503" },
  { "country": "Estonia", "iso2": "EE", "dial_code": "+372" },
  { "country": "Ethiopia", "iso2": "ET", "dial_code": "+251" },
  { "country": "Finland", "iso2": "FI", "dial_code": "+358" },
  { "country": "France", "iso2": "FR", "dial_code": "+33" },
  { "country": "Georgia", "iso2": "GE", "dial_code": "+995" },
  { "country": "Germany", "iso2": "DE", "dial_code": "+49" },
  { "country": "Ghana", "iso2": "GH", "dial_code": "+233" },
  { "country": "Greece", "iso2": "GR", "dial_code": "+30" },
  { "country": "Greenland", "iso2": "GL", "dial_code": "+299" },
  { "country": "Guatemala", "iso2": "GT", "dial_code": "+502" },
  { "country": "Haiti", "iso2": "HT", "dial_code": "+509" },
  { "country": "Honduras", "iso2": "HN", "dial_code": "+504" },
  { "country": "Hong Kong", "iso2": "HK", "dial_code": "+852" },
  { "country": "Hungary", "iso2": "HU", "dial_code": "+36" },
  { "country": "Iceland", "iso2": "IS", "dial_code": "+354" },
  { "country": "India", "iso2": "IN", "dial_code": "+91" },
  { "country": "Indonesia", "iso2": "ID", "dial_code": "+62" },
  { "country": "Iran", "iso2": "IR", "dial_code": "+98" },
  { "country": "Iraq", "iso2": "IQ", "dial_code": "+964" },
  { "country": "Ireland", "iso2": "IE", "dial_code": "+353" },
  { "country": "Israel", "iso2": "IL", "dial_code": "+972" },
  { "country": "Italy", "iso2": "IT", "dial_code": "+39" },
  { "country": "Jamaica", "iso2": "JM", "dial_code": "+1-876" },
  { "country": "Japan", "iso2": "JP", "dial_code": "+81" },
  { "country": "Jordan", "iso2": "JO", "dial_code": "+962" },
  { "country": "Kazakhstan", "iso2": "KZ", "dial_code": "+7" },
  { "country": "Kenya", "iso2": "KE", "dial_code": "+254" },
  { "country": "Kuwait", "iso2": "KW", "dial_code": "+965" },
  { "country": "Kyrgyzstan", "iso2": "KG", "dial_code": "+996" },
  { "country": "Latvia", "iso2": "LV", "dial_code": "+371" },
  { "country": "Lebanon", "iso2": "LB", "dial_code": "+961" },
  { "country": "Libya", "iso2": "LY", "dial_code": "+218" },
  { "country": "Lithuania", "iso2": "LT", "dial_code": "+370" },
  { "country": "Luxembourg", "iso2": "LU", "dial_code": "+352" },
  { "country": "Malaysia", "iso2": "MY", "dial_code": "+60" },
  { "country": "Maldives", "iso2": "MV", "dial_code": "+960" },
  { "country": "Mexico", "iso2": "MX", "dial_code": "+52" },
  { "country": "Moldova", "iso2": "MD", "dial_code": "+373" },
  { "country": "Monaco", "iso2": "MC", "dial_code": "+377" },
  { "country": "Mongolia", "iso2": "MN", "dial_code": "+976" },
  { "country": "Montenegro", "iso2": "ME", "dial_code": "+382" },
  { "country": "Morocco", "iso2": "MA", "dial_code": "+212" },
  { "country": "Nepal", "iso2": "NP", "dial_code": "+977" },
  { "country": "Netherlands", "iso2": "NL", "dial_code": "+31" },
  { "country": "New Zealand", "iso2": "NZ", "dial_code": "+64" },
  { "country": "Nigeria", "iso2": "NG", "dial_code": "+234" },
  { "country": "North Korea", "iso2": "KP", "dial_code": "+850" },
  { "country": "Norway", "iso2": "NO", "dial_code": "+47" },
  { "country": "Pakistan", "iso2": "PK", "dial_code": "+92" },
  { "country": "Panama", "iso2": "PA", "dial_code": "+507" },
  { "country": "Paraguay", "iso2": "PY", "dial_code": "+595" },
  { "country": "Peru", "iso2": "PE", "dial_code": "+51" },
  { "country": "Philippines", "iso2": "PH", "dial_code": "+63" },
  { "country": "Poland", "iso2": "PL", "dial_code": "+48" },
  { "country": "Portugal", "iso2": "PT", "dial_code": "+351" },
  { "country": "Qatar", "iso2": "QA", "dial_code": "+974" },
  { "country": "Romania", "iso2": "RO", "dial_code": "+40" },
  { "country": "Russia", "iso2": "RU", "dial_code": "+7" },
  { "country": "Saudi Arabia", "iso2": "SA", "dial_code": "+966" },
  { "country": "Serbia", "iso2": "RS", "dial_code": "+381" },
  { "country": "Singapore", "iso2": "SG", "dial_code": "+65" },
  { "country": "Slovakia", "iso2": "SK", "dial_code": "+421" },
  { "country": "Slovenia", "iso2": "SI", "dial_code": "+386" },
  { "country": "South Africa", "iso2": "ZA", "dial_code": "+27" },
  { "country": "South Korea", "iso2": "KR", "dial_code": "+82" },
  { "country": "Spain", "iso2": "ES", "dial_code": "+34" },
  { "country": "Sri Lanka", "iso2": "LK", "dial_code": "+94" },
  { "country": "Sweden", "iso2": "SE", "dial_code": "+46" },
  { "country": "Switzerland", "iso2": "CH", "dial_code": "+41" },
  { "country": "Syria", "iso2": "SY", "dial_code": "+963" },
  { "country": "Taiwan", "iso2": "TW", "dial_code": "+886" },
  { "country": "Thailand", "iso2": "TH", "dial_code": "+66" },
  { "country": "Tunisia", "iso2": "TN", "dial_code": "+216" },
  { "country": "Turkey", "iso2": "TR", "dial_code": "+90" },
  { "country": "Ukraine", "iso2": "UA", "dial_code": "+380" },
  { "country": "United Arab Emirates", "iso2": "AE", "dial_code": "+971" },
  { "country": "United Kingdom", "iso2": "GB", "dial_code": "+44" },
  { "country": "United States", "iso2": "US", "dial_code": "+1" },
  { "country": "Uruguay", "iso2": "UY", "dial_code": "+598" },
  { "country": "Uzbekistan", "iso2": "UZ", "dial_code": "+998" },
  { "country": "Venezuela", "iso2": "VE", "dial_code": "+58" },
  { "country": "Vietnam", "iso2": "VN", "dial_code": "+84" },
  { "country": "Yemen", "iso2": "YE", "dial_code": "+967" },
  { "country": "Zambia", "iso2": "ZM", "dial_code": "+260" },
  { "country": "Zimbabwe", "iso2": "ZW", "dial_code": "+263" }
];
 

    var tmp = props.value;
    tmp = tmp.replace(' ','');

    const [val, setVal] = useState(tmp);
    const [req, setRequired] = useState(props.req);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);


    const validate = (vx) => {
        return false;
      };


    const checkAndChange = (e) =>
    {
        var v = e.target.value;

        var pl = false;
        var anotherCountry = false;


        if(  v.includes(  '+48' ) ) pl = true;

       
        for(var k=0; k < numbs.length; k++)
        {
            if(   v.includes( numbs[k]["dial_code"] ) )
            {
                anotherCountry = true;
                break;
            }
        }
    

        if( anotherCountry )
        {
          
        }else
        {
          //  v = "+48" + v;
        }

         v = v.replace(/[^0-9+]/g, "")
    

        
         

        setVal(v);

        var correct = true;

       
        var cV = v.replace(" ","");

        if(pl)
        {
            if  (!( cV.length > 0 &&  (cV.length == 9 || cV.length == 12)  )) correct = false;
                    
            if( v.length == 0 && req != '1' ) correct = true; 
            if( v.length < 9 && req == '1' ) correct = false; 
        }else 
        {
           
        }
        
        console.log('PL',pl, correct);
       
        
                        
        
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = true;

        var pl = false;
        if(  val.includes(  '+48' ) ) pl = true;
        
        if(req == '1' &&  val != undefined ) 
        {
            if( pl &&  val.length != 9 && val.length != 12) correct = false;         
        }
    

      
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }

    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }

    
    useEffect(() => {

        if(val != props.value) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })

     

    var tmp = "";
    var pl = false;
    
    if(val != undefined)
    {        
        if(  val.includes(  '+48' ) ) pl = true;
    }

    if(val != undefined &&  pl &&  val.length == 12)
    {
    tmp += val.charAt(0);
    tmp += val.charAt(1);
    tmp += val.charAt(2);
    tmp += " ";
    tmp += val.charAt(3);
    tmp += val.charAt(4);
    tmp += val.charAt(5);
    tmp += " ";
    tmp += val.charAt(6);
    tmp += val.charAt(7);
    tmp += val.charAt(8);
    tmp += " ";
    tmp += val.charAt(9);
    tmp += val.charAt(10);
    tmp += val.charAt(11);
    }else tmp = val;




    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    } 



    var cnX = cn;
    if( val!=null &&  val.length < 1 && cnX == 'corrent')
    {
            cnX = '';
    }

    var defC = " w150 ";

    if(props.className != undefined)   
    {
        cnX = cnX + " " + props.className;
        defC = "";
    }

    var country = '';

     if(tmp.length > 6)
        {
                for(var k=0;k<numbs.length; k++)
                {
                    if( tmp.includes(numbs[k]["dial_code"]) ) 
                    {
                        country = " [" + numbs[k]["country"] + "]";
                    }
                }
        }

    
 



    return <fieldset>        
        <input type="phone"  value={tmp} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={ defC +  "  " + cnX} />        
        {imgx}{country}
        <br/>
             <span className="form_err">{err + " "} &nbsp; </span>        
    </fieldset>
}


export default InputPhone;